import { yup } from '@guiker/yup-util'

import { tenantPreference } from './tenant-preference'

export const upsertTenantPreference = yup.object({
  tenantPreference: tenantPreference.required(),
})

export type UpsertTenantPreference = yup.InferType<typeof upsertTenantPreference>
